//import LoadingView from '../ui/LoadingView';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import Bible from 'src/bible/Bible';
import SourceTextCache from 'src/new/sources/SourceTextCache';
//import VerseList from './VerseList';
//import VerseScroller from './VerseScroller';
//import VerseVersions from '../models/VerseVersions';
import VersionStore from 'src/new/versions/VersionStore';
import { Transport } from 'src/Transport';
//import BookVerses from '../js/BookVerses';
import Immutable from 'src/util/Immutable';
import SelectedVersions from 'src/versions/SelectedVersions';
import SearchQuery from '../search2/SearchQuery';
import BookVerseList from './BookVerseList';
import './VerseView.css';

export default class VerseView extends Component {
    static contextTypes = {
        bible: PropTypes.instanceOf(Bible).isRequired,
        //verses: PropTypes.array.isRequired,
        versions: PropTypes.instanceOf(VersionStore).isRequired
    }

    static propTypes = {
        //verseIndex: PropTypes.number,
        //bookVerses: PropTypes.instanceOf(BookVerses).isRequired,
        initialFocusedVerse: PropTypes.instanceOf(Immutable).isRequired,
        currentFocusedVerse: PropTypes.instanceOf(Immutable).isRequired,
        verseHistory: PropTypes.instanceOf(Immutable).isRequired,
        selectedVersions: PropTypes.instanceOf(SelectedVersions).isRequired,
        highlightQuery: PropTypes.instanceOf(SearchQuery),
        focusVerse: PropTypes.func.isRequired,
        onWordClick: PropTypes.func.isRequired,
        onBookChange: PropTypes.func.isRequired,
        onChapterChange: PropTypes.func.isRequired,
        onVerseChange: PropTypes.func.isRequired
    }

    constructor(props, context) {
        super(props);
        const initialVerse = context.bible.getVerse(0);
        /*this.state = {
            //verses: null
            //bookIndex: 0,
            initialFocusedVerse: Immutable.of(initialVerse),
            currentFocusedVerse: Immutable.of(initialVerse),
            verseHistory: Immutable.of(new VerseHistory(initialVerse))
        };*/
        this.sourceTextCache = new SourceTextCache();
        //this.focusVerse = this.focusVerse.bind(this);
        this.scrollToIndex = this.scrollToIndex.bind(this);
        //this.onBookChange = this.onBookChange.bind(this);
        //this.onChapterChange = this.onChapterChange.bind(this);
        //this.onVerseChange = this.onVerseChange.bind(this);
        this.onFocusedVerseChange = this.onFocusedVerseChange.bind(this);
        //this.doUpdateVerses = false;
        //this.updateVerses = this.updateVerses.bind(this);
        //this.onHeaderText = this.onHeaderText.bind(this);
        //this.onScroll = this.onScroll.bind(this);
        //this.onVerseChange = this.onVerseChange.bind(this);
    }

    /*componentDidMount() {
        VerseVersions.getForBook('5a7b2abc01f04f0fc49d5cd0', this.props.selectedVersions)
                .then(verses => this.setState({ verses: verses }))
                .catch(error => console.log(error));
    }*/

    /*componentDidMount() {
        this.updateVerses();
    }

    componentWillReceiveProps(nextProps) {
        this.doUpdateVerses = true;
    }

    componentDidUpdate(prevProps) {
        if (this.doUpdateVerses) {
            this.doUpdateVerses = false;
            this.updateVerses();
        }
    }

    updateVerses() {
        const verseIndex = this.props.verseIndex;
        if (verseIndex === null) {
            this.setState({ verses: new BookVerses([]) });
            return;
        }

        if (this.state.verses && this.state.verses.containsVerse(verseIndex)) {
            this.scrollToIndex(this.state.verses.getArrayPositionForVerse(verseIndex));
            return;
        }

        this.setState({ verses: null });
        VerseVersions.getBookForVerse(verseIndex)
                .then(bookVerses => {
                    const verses = new BookVerses(bookVerses);
                    this.setState({ verses }, () =>
                        this.scrollToIndex(verses.getArrayPositionForVerse(verseIndex)));
                })
                .catch(error => console.log(error));
    }*/

    /*focusVerse(verse) {
        this.setState({
            initialFocusedVerse: Immutable.of(verse),
            currentFocusedVerse: Immutable.of(verse),
            verseHistory: this.state.verseHistory.mutate(value => value.addVerse(verse))
        });
    }*/

    scrollToIndex(index) {
        /*if (this.verseList) {
            this.verseList.scrollToIndex(index);
        }*/
        //this.setState({ verseIndex: index });
        this.props.focusVerse(this.context.bible.getVerse(index));
    }

    /*onHeaderText(text) {
        this.setState({ headerText: text });
    }

    onScroll(verseIndex) {
        if (this.scroller) {
            this.scroller.scrollTo(verseIndex);
        }
    }

    onVerseChange(verseIndex) {
        this.scrollToIndex(verseIndex);
    }*/

    //onBookChange(bookIndex) {
    //    this.props.focusVerse(this.context.bible.getBook(bookIndex).getChapter(1).getVerse(1));
        /*this.setState({
            focusedVerse: verse,
            verseIndex: verse.getIndex()
        });*/
    //}

    //onChapterChange(chapterIndex) {
    //    this.props.focusVerse(this.context.bible.getChapter(chapterIndex).getVerse(1));
        /*this.setState({
            focusedVerse: verse,
            verseIndex: verse.getIndex()
        });*/
    //}

    //onVerseChange(verseIndex) {
    //    this.props.focusVerse(this.context.bible.getVerse(verseIndex));
        /*this.setState({
            focusedVerse: verse,
            verseIndex: verse.getIndex()
        });*/
    //}

    onFocusedVerseChange(verse) {
        this.setState({
            currentFocusedVerse: Immutable.of(verse)
        });
    }

    render() {
        //const verses = this.state.verses;
        //var content;
        /*if (verses === null) {
            content = <LoadingView />;
        } else*/ /*if (this.props.selectedVersions.selectedCount() === 0) {
            content = <div className="VerseView_Empty">Choose some versions to display</div>;*/
        //} else if (verses.count() === 0) {
        //    content = <div className="VerseView_Empty">Choose a verse to display</div>;
        //} else {
            /*content = (
                <div className="VerseView_List">
                    <VerseList
                        ref={element => this.verseList = element}
                        bookVerses={null/*verses*//*}
                        selectedVersions={this.props.selectedVersions}
                        highlightQuery={this.props.highlightQuery}
                        onWordClick={this.props.onWordClick} />
                </div>
            );*/
        //}
        return (
            <div className="VerseView">
                <ReactTooltip id="VerseTextTooltip" effect="solid" place="bottom" />
                {/*<div className="VerseView_Header">
                    <VerseHeader
                        focusedVerse={this.props.currentFocusedVerse.get()}
                        bible={this.context.bible}
                        showVerse={this.props.selectedVersions.selectedCount() !== 1}
                        verseHistory={this.props.verseHistory}
                        onBookChange={this.onBookChange}
                        onChapterChange={this.onChapterChange}
                        onVerseChange={this.onVerseChange} />
                </div>*/}
                <div className="VerseView_Header">
                    <Transport
                        focusedVerse={this.props.currentFocusedVerse.get()}
                        bible={this.context.bible}
                        showVerse={this.props.selectedVersions.selectedCount() !== 1}
                        onBookChange={this.props.onBookChange}
                        onChapterChange={this.props.onChapterChange}
                        onVerseChange={this.props.onVerseChange} />
                </div>
                <div className="VerseView_List">
                    <BookVerseList
                        initialFocusedVerse={this.props.initialFocusedVerse}
                        currentFocusedVerse={this.props.currentFocusedVerse}
                        versions={this.context.versions}
                        selectedVersions={this.props.selectedVersions}
                        sourceTextCache={this.sourceTextCache}
                        highlightQuery={this.props.highlightQuery}
                        onFocusedVerseChange={this.onFocusedVerseChange}
                        onWordClick={this.props.onWordClick} />
                </div>
                {/*content*/}
            </div>
        );
    }
}
